<template>
    <div>
        <!--折扣课程-->
        <course-list title="学员专属课程" class-type="boutique"/>
    </div>

</template>

<script>
    import CourseList from "@components/course/CourseList";

    export default {
        name: "ExclusiveCourses",
        components: {
            CourseList
        }
    }
</script>

<style scoped>

</style>
